import { ReactNode } from 'react'

interface TelegramSetupStepItemProps {
    number: number
    title: string
    children: ReactNode
}

export const TelegramSetupStepItem = ({ number, title, children }: TelegramSetupStepItemProps) => (
    <li className="flex gap-2.5">
        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent text-[11px] font-semibold text-accent-foreground">
            {number}
        </span>
        <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">{title}</p>
            <div className="text-xs leading-snug text-foreground-muted">{children}</div>
        </div>
    </li>
)
